export enum ActionTypes {
  REQUEST = "@auth/validate/REQUEST",
  SUCCESS = "@auth/validate/SUCCESS",
  FAILURE = "@auth/validate/FAILURE",
  CLEAN = "@auth/validate/CLEAN",
}
